module.exports = __webpack_public_path__ + "media/images/builder/qr_example-bb91e9a532030f60509039a81f55ad48.jpg";